let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2pUJk")).then(() => parcelRequire('48wMp'));